import { CatalogViewGroupBy, IsMaterializeGroupingParams } from './catalogView.types';

export const isMaterializeGrouping = ({
  configSnapshot,
  dirtyForAll,
  draft,
}: IsMaterializeGroupingParams): boolean =>
  dirtyForAll.includes('groupBy') &&
  draft.groupBy === CatalogViewGroupBy.MANUAL &&
  configSnapshot.groupBy !== CatalogViewGroupBy.MANUAL;
